import { authFetch } from './authFetch.js';
import { cleanText } from './pi-parse.js';

const KEY = 'sp.scan.session.v1';

/**
 * ค้นบาร์โค้ดใน PD — ฝั่ง PD เทียบตรงตัวอย่างเดียว (ไม่เติม 0 ให้ ไม่แปลง UPC-A ↔ EAN-13)
 * เลยต้องลองรูปแบบที่เป็นไปได้เองทีละอัน
 */
export async function lookupBarcode(raw) {
  const literal = cleanText(raw).trim();
  const variants = [literal];
  if (/^\d{12}$/.test(literal)) variants.push('0' + literal);      // UPC-A → รูป EAN-13
  if (/^0\d{12}$/.test(literal)) variants.push(literal.slice(1));  // EAN-13 ขึ้นต้น 0 → รูป UPC-A

  for (const v of variants) {
    const o = await authFetch(`/api/pd/search?barcode=${encodeURIComponent(v)}`, { method: 'GET' });
    const all = o.rows || [];
    if (!all.length) continue;
    const rows = all.filter(r => r.is_active !== false);
    if (!rows.length) return { status: 'inactive', rows: all, matched_as: v };
    if (rows.length === 1) return { status: 'hit', hit: rows[0], matched_as: v };
    return { status: 'ambiguous', rows, matched_as: v }; // %/_ ในโค้ดที่ยิงไปโดน ilike ของขา sku
  }
  return { status: 'miss', literal };
}

/** บรรทัดตะกร้า = คีย์เดียวกับที่หน้า "ซื้อ" บนคอมสร้าง (QuickBuy addToCart) เป๊ะ ๆ */
export const cartLineFrom = p => ({
  sku: p.sku,
  name: p.name,
  barcode: p.barcode,
  image_url: p.image_url,
  purchase_cost: p.purchase_cost,
  on_hand: p.on_hand,
  qty: 1,
  unit_cost: p.purchase_cost != null ? String(p.purchase_cost) : '', // string เสมอ (null ทำ input คอมหลุด controlled)
});

export const uid = () => `u_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 6)}`;

export function buildPayload({ supplier, note, cart, unknown, base }) {
  return {
    ...(base || {}),          // เก็บคีย์อื่นที่หน้าคอมอาจใส่ไว้
    supplier: supplier || '',
    note: note || '',
    cart,
    unknown,
    scan_meta: { source: 'mobile-scan', app: 'sourcepoint', v: 1, saved_at: new Date().toISOString() },
  };
}

export function buildTitle(cart, unknown) {
  const head = cart[0]?.name || (unknown[0] ? `บาร์โค้ด ${unknown[0].barcode}` : 'สแกน');
  const more = cart.length + unknown.length - 1;
  const un = unknown.length ? ` · ไม่รู้จัก ${unknown.length}` : '';
  return `สแกน · ${head}${more > 0 ? ` +${more}` : ''}${un}`.slice(0, 120);
}

// กันของหาย: iOS ฆ่า PWA ทิ้งบ่อย + session หมดอายุกลางทางแล้วต้องล็อกอินใหม่
export const saveLocal = s => {
  try {
    if (!s.cart?.length && !s.unknown?.length) { localStorage.removeItem(KEY); return; }  // ไม่มีของ = ไม่ต้องเก็บ
    localStorage.setItem(KEY, JSON.stringify({ ...s, at: Date.now() }));
  } catch { /* เต็ม */ }
};
export const loadLocal = () => { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch { return null; } };
export const clearLocal = () => { try { localStorage.removeItem(KEY); } catch { /* ignore */ } };
